import { NALU } from './nalu';

/**
 * SEI 编解码器
 *
 * 用途：实现 SEI Message 的收发
 */
export class SEIEncoder {
  private _seiMessageList: Array<ArrayBuffer> = [];
  private _smallSeiMessageList: Array<ArrayBuffer> = [];
  private _seiPayloadType = 243;
  /**
  * 将业务侧发的 sei message 封装成 sei NALU
  * @param {ArrayBuffer} buffer
  * @returns {NALU}
  */
  encodeSEINalu(buffer: ArrayBuffer) {
    const payloadSize = buffer.byteLength;
    // payload size 读取规则是读到非 0xff 为止。
    // payload size = a * 0xff + b;
    const a = parseInt(String(payloadSize / 255), 10);
    const b = payloadSize % 255;
    // 0x00000001, 0x6, 0x5, a 个 0xff, b, sei 内容, 0x80 sei 固定结尾。
    const arr = [];
    arr.push(0, 0, 0, 1, 6, this._seiPayloadType);
    for (let i = 0; i < a; i++) {
      arr.push(255);
    }
    arr.push(b);
    const seiContentView = new DataView(buffer);
    arr.push(...new Uint8Array(seiContentView.buffer));
    // sei nalu 结尾 0x80
    arr.push(128);
    return new NALU(new DataView(new Uint8Array(arr).buffer), true);
  }
  sendSEI(buffer: ArrayBuffer, options: { small: boolean; seiPayloadType: number; }) {
    if (options?.seiPayloadType) {
      this._seiPayloadType = options.seiPayloadType;
    }
    this._seiMessageList.push(buffer);
    if (options?.small) {
      this._smallSeiMessageList.push(buffer);
    }
  }
  isEmpty() {
    return !this._seiMessageList.length;
  }
  /**
   * 获取视频帧中有几个 nalu
   * @returns {Number}
   */
  getNaluCount(arrayBuffer: ArrayBuffer) {
    let zeroCount = 0;
    let naluCount = 0;
    const dataView = new DataView(arrayBuffer);
    for (let i = 0; i < arrayBuffer.byteLength; i++) {
      switch (dataView.getUint8(i)) {
        case 0:
          zeroCount++;
          break;
        case 1:
          // nalu start code 001, 0001
          if (zeroCount === 2 || zeroCount === 3) {
            naluCount++;
          }
          zeroCount = 0;
          break;
        default:
          zeroCount = 0;
          break;
      }
    }

    return naluCount;
  }
  encode(frame: RTCEncodedVideoFrame, small: boolean) {
    const seiMessageList = small ? this._smallSeiMessageList : this._seiMessageList;
    if (seiMessageList.length > 0 && frame.data.byteLength > 0) {
      const naluCount = this.getNaluCount(frame.data);
      // sei nalu + 视频帧 nalu 不能超过 9，否则会丢帧。
      const seiCountToSend = 9 - naluCount;
      if (seiCountToSend <= 0) return 0;
      // 与 native 对齐，将 sei nalu 逆序插入到视频帧 nalu 之前
      // sendSEI 1 2 3 => seiNalu(3), seiNalu(2), seiNalu(1), videoNalu
      const seiNaluList = seiMessageList
        .splice(0, seiCountToSend)
        .reverse()
        .map(this.encodeSEINalu.bind(this));
      const totalSEINaluByteLength = seiNaluList.reduce(
        (result, current) => result + current.dataView.byteLength,
        0
      );
      const arrayBuffer = new ArrayBuffer(totalSEINaluByteLength + frame.data.byteLength);
      const dataView = new DataView(arrayBuffer);
      const videoFrameDataView = new DataView(frame.data);
      let index = 0;
      // 将 sei nalu 塞到 video frame nalu 之前
      for (let i = 0; i < seiNaluList.length; i++) {
        for (let j = 0; j < seiNaluList[i].dataView.byteLength; j++) {
          dataView.setInt8(index++, seiNaluList[i].dataView.getInt8(j));
        }
      }
      for (let i = 0; i < frame.data.byteLength; i++) {
        dataView.setInt8(index++, videoFrameDataView.getInt8(i));
      }
      frame.data = arrayBuffer;
      return seiNaluList.length;
    }
    return 0;
  }
}
